import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagNA = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#A2001D",
  d: "M7.321 42.677a25.147 25.147 0 0 0 3.342 2.807l34.821-34.821a25.143 25.143 0 0 0-6.149-6.149L4.515 39.336a25.16 25.16 0 0 0 2.806 3.34Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M7.322 7.323c-7.887 7.887-9.401 19.732-4.545 29.14L36.462 2.779C27.054-2.078 15.21-.564 7.322 7.323Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#496E2D",
  d: "M42.677 42.678c7.887-7.887 9.401-19.732 4.546-29.14L13.537 47.222c9.408 4.856 21.253 3.342 29.14-4.545Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m20.651 14.13-2.8 1.318 1.49 2.713-3.041-.582-.386 3.073-2.118-2.26-2.12 2.26-.385-3.073-3.041.582 1.491-2.713L6.94 14.13l2.801-1.318L8.25 10.1l3.041.581.386-3.073 2.119 2.26 2.119-2.26.385 3.073 3.042-.581-1.492 2.713 2.801 1.317Z"
}));
FlagNA.displayName = 'FlagNA';
export default withFlagWrapper(FlagNA);
//# sourceMappingURL=index.js.map